import KnowLedgeCard from "@/components/knowledge"
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { IconPlus } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { ListngKnowKeys } from '@/store/actions'
import { useDispatch, useSelector } from "react-redux";
import KnowledgeDialog from "@/components/dialog/knowledgeDialog";
import { useLoginData } from "@/store/context/LoginContext";
import { AddKnowledge } from "@/store/actions";
import { AppDispatch } from "@/store";
import { RootState } from "@/store/reducer";

const  Knowledge: React.FC = () => {

    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [knowledgeData, setKnowledgeData] = useState([]);
    const [flowData, setFlowData] = useState<any>([]);
    const {user, setUser} = useLoginData();


    const KnowledgeDetails = (data: any) => {
        navigate(`/knowledge/${data?.keys}`, { state: { data: data }});
    };

    const dispatch = useDispatch<AppDispatch>();
    const { data, loading } = useSelector((state: RootState) => state.keyKnowReducer);

    useEffect(() => {
        if (user) {
            dispatch(ListngKnowKeys(user.id));
        }
    }, [user, dispatch]);

    const AddKnowledgeModel = () => setIsModalOpen(!isModalOpen)

    useEffect(() => {
        const handleKnowledgeData = async () => {
            if (flowData?.name && user?.id) { // Check if flowData.name and user.id are defined
                const knowData = { 
                    user_id: user.id, 
                    name: flowData.name, 
                    flowData: [flowData] 
                };
                console.log(knowData);
    
                try {
                    // Dispatch actions and wait for the promises to resolve
                    await dispatch(AddKnowledge(knowData));
                    await dispatch(ListngKnowKeys(user.id));
                    
                    // Call the AddKnowledgeModel function
                    setIsModalOpen(false)
                } catch (error) {
                    console.error('Error handling knowledge data:', error);
                }
            }
        };
    
        handleKnowledgeData();
    }, [flowData, user]); // Include user in the dependency array
    

      

	return (
		<>
        <div className="container ">
			{/* <h1 className="text-3xl font-bold  m-6 ml-0">Knowledge</h1> */}
            <div className="flex w-full flex-row gap-6 items-center justify-between md:py-4">
                    <h2 className="text-gray-900 text-3xl mt-4 font-bold">Knowledge</h2>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={AddKnowledgeModel}
                        className="inline-flex items-center"
                    >
                        <IconPlus className="mr-2" />
                        <span>New</span>
                    </Button>
                </div>

                <div className='flex flex-col rounded-lg border border-gray-200'>
                    {data && data.length > 0 ? (
                        data?.map((item, index) => (
                            <div className='w-full mr-3 rounded-lg bg-white' key={index}>
                                <KnowLedgeCard
                                    title={item.name}
                                    number_document={1}
                                    id={item?.id}  // Ensure to pass the id here
                                    onDotsClick={() => KnowledgeDetails(item)} // Handle the dots icon click
                                />
                            </div>
                        ))
                    ) : (
                        <div className='w-full text-center p-4 text-gray-500'>
                            No record found
                        </div>
                    )}
                </div>
            <KnowledgeDialog
                                isOpen={isModalOpen}
                                onClose={AddKnowledgeModel}
                                setTags={setKnowledgeData}
                                tags={knowledgeData}
                                flowData={flowData}
                                setFlowData={setFlowData}
                            />
            </div>
		</>
	)
}

export default  Knowledge;